import { atom, } from 'recoil'
import { recoilPersist } from 'recoil-persist'
const { persistAtom } = recoilPersist({
    key: 'misUserData', // this key is using to store data in local storage
    storage: localStorage, // configurate which stroage will be used to store the data
})

export const UserAuthState = atom({
    key: 'misUserData',
    default: {

        misUserData: null,

    },

    effects_UNSTABLE: [persistAtom],
})

export const ReportsFilterState = atom({
    key: 'reportsFilterState',
    default: {
        searchInput: '',
        dates: null,
        statusFilter: 'payments',
        paginationModel: { page: 0, pageSize: 15 },
        appliedFilterNames: [],
        filterCount: 0,
        filterDatas: {
            selectedCourse: [],
            selectedAddmisonProcess: [],
            selectedPaymentModes: [],
            selectedFamilyIncome: [],
            selectedBuddy: [],
            selectedBatchMode: [],
            selectedTag: [],
            selectedBatches: [],
            selectedOccupation: [],
            selectedCountry: [],
            selectedPaymentStatus: [],
            selectedAddon: [],
            selectedCity: [],
            selectedState: [],
            selectedBoard: [],
            selectedReference: [],
            selectedCareerOptions: [],
            selectedSource: [],
            selectedNextExpectedCource: [],
            selectedSchool: [],
            selectedCreatedBy: [],
            excludedPaymentModes: [],
            excludedFamilyIncome: [],
            excludedBuddy: [],
            excludedTag: [],
            excludedBatches: [],
            excludedOccupation: [],
            excludedCountry: [],
            excludedPaymentStatus: [],
            excludedCourse: [],
            excludedAddmisonProcess: [],
            excludedAddon: [],
            excludedBatchMode: [],
            excludedState: [],
            excludedCity: [],
            excludedBoard: [],
            excludedReference: [],
            excludedCareerOptions: [],
            excludedSource: [],
            exculdedNextExpectedCource: [],
            excludedSchool: [],
            excludedCreatedBy: [],
            selectedCounsellor: [],  
            excludedCounsellor: [], 
            selectedBloodGroup: [],
            excludedBloodGroup: [],
            selectedPreviousClass: [],
            excludedPreviousClass: [],
            selectedDesignation: [],
            excludedDesignation: [],
            selectedBanks: [],
            excludedBanks: [],
            dateFilter: { startDate: '', endDate: '' },
        }
    },
    effects_UNSTABLE: [persistAtom],
})